export const SET_USERS_DATA = 'SET_USERS_DATA';
export const SET_CATEGORY_DATA = 'SET_CATEGORY_DATA';
export const SET_BOOKING_DATA = 'SET_BOOKING_DATA';

// Action creators
export const setOrderData = (orderData) => ({
  type: SET_ORDER_DATA,
  payload: { orderData }
});

export const setUsersData = (usersData) => ({
  type: SET_USERS_DATA,
  payload: { usersData }
});

export const setBookingData = (bookingData) => ({
  type: SET_BOOKING_DATA,
  payload: { bookingData }
});

export const setCategoryData = (categoryData) => ({
  type: SET_CATEGORY_DATA,
  payload: { categoryData }
});

export const setPromoData = (promoData) => ({
  type: SET_PROMO_DATA,
  payload: { promoData }
});

export const setLocationData = (locationData) => ({
  type: SET_LOCATION_DATA,
  payload: { locationData }
});

export const setCountryCodeData = (countryCodeData) => ({
  type: SET_COUNTRY_CODE,
  payload: { countryCodeData }
});

export const setMenuData = (menudata) => ({
  type: SET_MENU_DATA,
  payload: { menudata }
});

export const setPostData = (postdata) => ({
  type: SET_POST_DATA,
  payload: { postdata }
});

export const setDriverRegRequestData = (data) => ({
  type: SET_DRIVER_REG_REQUEST_DATA,
  payload: { data }
});
